import styled from 'styled-components';
import { Popup as SemanticTooltip } from 'semantic-ui-react';

export const TableCell = styled.div`
  min-width: 120px;
  max-width: 120px;
  color: ${(props) => props.theme.color.textSecondary};
  align-items: center;
  justify-content: center;
  text-align: ${(props) => (props.row ? 'left' : 'center')};
  word-wrap: break-word;
`;

export const Tooltip = styled(SemanticTooltip)`
  &.ui.popup {
    background: #FFF;
    border: solid 1px ${({ theme }) => theme.color.tooltipDescription};

    :before {
      background: #FFF;
      box-shadow: 1px 1px 0 0 ${({ theme }) => theme.color.tooltipDescription};
    }
  }
`;

export const TooltipDescription = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background: #FFF;
  border-radius: 100%;
`;
